import { AbstractModel } from "../base";
import type { ISignableDocument, ISignableDocumentData } from "./legal-document.types";

export class SignableDocument extends AbstractModel implements ISignableDocument {
    readonly id?: number
    readonly title: string
    readonly signer_name: string
    readonly signer_email: string
    readonly signer_title: string
    readonly is_signed: boolean = false
    readonly created?: Date
    readonly modified?: Date

    constructor(data: ISignableDocumentData) {
        super()

        // Validate data
        const requiredFields: (keyof ISignableDocumentData)[] = ['title', 'signer_name', 'signer_email', 'signer_title']
        this.validate(data, requiredFields)

        // Initialize object assuming data valid
        this.title = data.title!
        this.signer_name = data.signer_name!
        this.signer_email = data.signer_email!
        this.signer_title = data.signer_title!
        if (data.id) {
            this.id = data.id   
        }

        if (data.is_signed) {
            this.is_signed = data.is_signed
        }

        if (data.created) {
            this.created =
                typeof data.created === 'string' ? new Date(data.created) : data.created
        }

        if (data.modified) {
            this.modified =
                typeof data.modified === 'string' ? new Date(data.modified) : data.modified
        }
    }
}